import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

export const sendGroupMessage = (params) => {
  return Api(endPoints.sendGroupMessage, params, requestType.POST);
};

